import React, { useState } from "react";

import { MenuList, PageHeader } from "components";

import { Container, Content } from "./styles";

export interface ILeftMenu {
  menuTitle: string;
  currentLocale: string;
  type: "report" | "administration";
  menuList: Array<IListItem>;
  backgroundHeader?: "primary" | "secondary";
  navigate: (router: string) => unknown;
}

export interface IListNavigation {
  menuTitle: string;
  locale: string;
  read: boolean;
}

export interface IListItem {
  title: string;
  navigation: Array<IListNavigation>;
}

export const LeftMenu: React.FC<ILeftMenu> = ({
  menuTitle,
  currentLocale,
  menuList,
  backgroundHeader = "secondary",
  navigate,
}) => {
  const [select, setSelected] = useState("cadastros");
  return (
    <Container>
      <PageHeader label={menuTitle} background={backgroundHeader} />
      <Content>
        {menuList.map((item) => (
          <MenuList
            key={item.title}
            currentLocale={currentLocale}
            title={item.title}
            handleOpen={(e) => setSelected(e)}
            open={select}
            list={item.navigation}
            navigate={navigate}
          />
        ))}
      </Content>
    </Container>
  );
};
